Vue.component('SidebarMenu', require('./components/SidebarMenu').default);
